import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
} from 'semantic-ui-react';

function KybApproveConfirmationModal({
  shown,
  onClose,
  onConfirm,
  businessOrOwnerName,
  isLoading,
}) {
  return (
    <Modal open={shown} onClose={onClose}>
      <ModalHeader>Confirm Approve KYB</ModalHeader>
      <ModalContent>
        <p>
          Are you sure to Approve <strong>{businessOrOwnerName}</strong> ?
        </p>
      </ModalContent>
      <ModalActions>
        <Button onClick={onClose} loading={isLoading} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          positive
          onClick={onConfirm}
          loading={isLoading}
          disabled={isLoading}
        >
          Confirm
        </Button>
      </ModalActions>
    </Modal>
  );
}

KybApproveConfirmationModal.propTypes = {
  shown: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  businessOrOwnerName: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default KybApproveConfirmationModal;
